import React from "react";

export interface CircledNumberProps {
  number: number;
  color?: string;
}

export const CircledNumber = ({ ...props }: CircledNumberProps) => {
  return (
    <div
      style={{
        width: "25px",
        height: "25px",
        borderRadius: "50%",
        backgroundColor: props.color || "#1F47D3",
        color: "white",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "15px",
        fontWeight: "bold",
      }}
    >
      {props.number}
    </div>
  );
};
